import React, { useContext, useState } from 'react';
import { SchoolContext } from '../../context/SchoolContext';
import Card from '../ui/Card';
import Input from '../ui/Input';
import Button from '../ui/Button';
import List from '../ui/List';

const AssessmentManagement = () => {
    const { assessments, setAssessments } = useContext(SchoolContext);
    const [newAssessment, setNewAssessment] = useState('');

    const handleAddAssessment = (e) => {
        e.preventDefault();
        if (newAssessment.trim() === '') return;
        setAssessments(prev => [...prev, { id: Date.now(), name: newAssessment.trim() }]);
        setNewAssessment('');
    };

    const handleGenerateReport = (assessmentName) => {
        alert(`Generating report for: ${assessmentName}`);
        // In a real application, you would trigger a PDF generation or a new report view here.
    };

    const renderAssessment = (assessment) => (
        <li key={assessment.id} className="py-3 flex justify-between items-center">
            <span className="font-semibold">{assessment.name}</span>
            <button onClick={() => handleGenerateReport(assessment.name)} className="px-3 py-1 text-sm text-white bg-green-600 rounded-md hover:bg-green-700">
                Generate Report
            </button>
        </li>
    );

    return (
        <Card title="Assessment Management">
            <form onSubmit={handleAddAssessment} className="mb-6">
                <h4 className="text-lg font-semibold mb-2">Create New Assessment</h4>
                <div className="flex flex-col space-y-2">
                    <Input type="text"
                           placeholder="e.g., Semester Assessment"
                           value={newAssessment}
                           onChange={(e) => setNewAssessment(e.target.value)} />
                    <Button type="submit">Add Assessment</Button>
                </div>
            </form>

            <div>
                <h3 className="text-lg font-semibold mb-2">Existing Assessments</h3>
                <List items={assessments} renderItem={renderAssessment} />
            </div>
        </Card>
    );
};

export default AssessmentManagement;
